import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';

export const selectHouseYear = createSelector(selectJsonQuery, jsonQuery => getRangeValue('house_year')(jsonQuery));
